import React from 'react'
import PropTypes from 'prop-types'
import { useSelector, useDispatch } from 'react-redux'
import classNames from 'classnames'
import Checkbox from '@material-ui/core/Checkbox'
import TableCell from '@material-ui/core/TableCell'
import TableRow from '@material-ui/core/TableRow'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableHead from '@material-ui/core/TableHead'
import Collapse from '@material-ui/core/Collapse'
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown'
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp'
import IconButton from '@material-ui/core/IconButton'
import { withStyles } from '@material-ui/core/styles'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import { Translation } from 'react-i18next'
import {
  removeInvoice,
  copyInvoice,
  invoiceDownloadPDF,
  editInvoice,
  warnInvoiceToDelete,
  reminderInvoiceDownloadPDF,
  cancelDeleteInvoice,
  cancelEditInvoice,
  addCreditNoteInvoice,
  showInvoiceFormDialog
  /* warnRecoveryToSend,
  cancelRecoverySend,
  recoveryInvoice */
} from '../../actions/'
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank'
import CheckBoxIcon from '@material-ui/icons/CheckBox'
import FontAwesome from 'react-fontawesome'
import {
  convertIntToState,
  getInvoiceStatusStyle
} from '../../utils/invoice.utils'
import mobileView from '../../utils/mobile.utils'

const styles = (theme) => ({
  tablecell: {
    fontSize: '12px',
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    borderBottom: 'none'
  },
  button: {
    margin: theme.spacing(1)
  },
  root: {
    backgroundColor: theme.palette.common.dialogBackground
  },
  collapseTableRow: {
    height: '10px'
  },
  collapseTableCell: {
    fontSize: '12px',
    borderBottom: 'none'
  },
  collapseTableHeader: {
    fontWeight: '500',
    fontSize: '13px',
    color: 'black',
    borderBottom: 'none'
  },
  collapseColumn1: {
    paddingLeft: '20px',
    width: '57%',
    [theme.breakpoints.down('450')]: {
      width: '58%'
    }
  },
  collapseColumn3: {
    paddingLeft: '0 !important'
  }
})

const InvoiceRow = ({
  index,
  id,
  invoiceRowData,
  billing_date,
  due_date,
  customer,
  invoice_id,
  totalSumWithVAT,
  status,
  instant_payment,
  remindersent,
  is_group_invoice,
  attached_journal_id,
  classes
}) => {
  const isToDelete = useSelector((state) => state.invoice.isToDelete)
  const isToDeleteInvoiceId = useSelector(
    (state) => state.invoice.isToDeleteInvoiceId
  )
  const isToDetach_workshift_journal_id = useSelector(
    (state) => state.invoice.isToDetach_workshift_journal_id
  )
  const dispatch = useDispatch()

  const [open, setOpen] = React.useState(false)

  return (
    <Translation>
      {(t) => {
        return (
          <React.Fragment>
            <TableRow
              key={id}
              style={
                index % 2 ? { background: 'white' } : { background: '#ebf9fa' }
              }
            >
              <TableCell
                component="th"
                scope="row"
                className={classNames(classes.tablecell, 'hide-mobile')}
                style={{
                  paddingRight: '10px'
                }}
              >
                {customer}
              </TableCell>
              <TableCell
                component="th"
                scope="row"
                className={classes.tablecell}
                style={{
                  paddingRight: '10px'
                }}
              >
                {invoice_id}
              </TableCell>
              <TableCell
                component="th"
                scope="row"
                className={classes.tablecell}
                style={{
                  paddingRight: '10px'
                }}
              >
                {totalSumWithVAT} {is_group_invoice ? '(*G)' : ''}
              </TableCell>
              <TableCell
                component="th"
                scope="row"
                className={classNames(classes.tablecell, 'hide-mobile')}
                style={{
                  paddingRight: '10px'
                }}
              >
                {billing_date}
              </TableCell>
              <TableCell
                component="th"
                scope="row"
                className={classNames(classes.tablecell, 'hide-mobile')}
                style={{
                  paddingRight: '10px'
                }}
              >
                {due_date}
              </TableCell>
              <TableCell
                component="th"
                scope="row"
                className={classNames(classes.tablecell, 'hide-mobile')}
                style={{
                  paddingRight: '10px'
                }}
              >
                <div
                  style={getInvoiceStatusStyle(status, invoiceRowData.due_date)}
                >
                  {convertIntToState(status, 'userView')}
                </div>
              </TableCell>
              <TableCell
                component="th"
                scope="row"
                className={classNames(classes.tablecell, 'hide-mobile')}
                style={{
                  paddingRight: '10px'
                }}
              >
                <Checkbox
                  checked={instant_payment === 'quick_pay' ? true : false}
                  disabled={true}
                  icon={<CheckBoxOutlineBlankIcon fontSize="large" />}
                  checkedIcon={<CheckBoxIcon fontSize="large" />}
                />
              </TableCell>
              <TableCell
                scope="row"
                className={classes.tablecell}
                style={{ paddingRight: '10px', paddingLeft: '10px' }}
              >
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <p
                      style={{ margin: '10px 15px 10px 10px' }}
                      className="link"
                      onClick={() => {
                        dispatch(invoiceDownloadPDF(invoice_id))
                      }}
                    >
                      <FontAwesome
                        title={t('iconTitle.generatePdf')}
                        name="file-pdf-o"
                        size="lg"
                      />
                    </p>
                    {[1, 3, 11].includes(status) &&
                    Number.parseFloat(
                      totalSumWithVAT.replace(/−/g, '-').replace(/,/g, '.')
                    ) > 0 &&
                    !is_group_invoice ? (
                      <p
                        style={{ margin: '10px 15px 10px 10px' }}
                        className="link"
                        onClick={() => {
                          dispatch(addCreditNoteInvoice(invoice_id))
                          dispatch(showInvoiceFormDialog())
                        }}
                      >
                        <FontAwesome
                          title={t('iconTitle.addCreditNote')}
                          name="undo"
                          size="lg"
                        />
                      </p>
                    ) : null}
                    {actionsByState(status, invoice_id, dispatch)}
                    {status === 0 ? (
                      <p
                        style={{
                          marginLeft: '10px',
                          color: '#F67131',
                          marginTop: '10px'
                        }}
                        className="link"
                        onClick={() => {
                          dispatch(cancelEditInvoice())
                          dispatch(
                            warnInvoiceToDelete(invoice_id, attached_journal_id)
                          )
                        }}
                      >
                        <FontAwesome
                          title={t('iconTitle.deleteInvoice')}
                          name="window-close"
                          size="lg"
                        />
                      </p>
                    ) : (
                      <p
                        style={{
                          marginLeft: '10px',
                          color: 'Gray',
                          paddingTop: '10px'
                        }}
                      >
                        <FontAwesome
                          name="window-close"
                          className="fa-disable"
                          size="lg"
                        />
                      </p>
                    )}
                    {remindersent === 1 && status !== 2 && (
                      <p
                        style={{ margin: '10px 15px 10px 20px' }}
                        className="link"
                        onClick={() => {
                          dispatch(reminderInvoiceDownloadPDF(invoice_id))
                        }}
                      >
                        <FontAwesome
                          title={t('iconTitle.generateReminderPDF')}
                          name="sticky-note"
                          size="lg"
                        />
                      </p>
                    )}
                  </div>
                  <div
                    style={{
                      width: '100%',
                      display: 'flex',
                      justifyContent: 'flex-end'
                    }}
                  >
                    {mobileView ? (
                      <IconButton
                        aria-label="expand row"
                        size="small"
                        onClick={() => {
                          setOpen(!open)
                        }}
                      >
                        {open ? (
                          <KeyboardArrowUpIcon />
                        ) : (
                          <KeyboardArrowDownIcon />
                        )}
                      </IconButton>
                    ) : null}
                  </div>
                </div>
                <Dialog
                  open={isToDelete}
                  onClose={() => {
                    dispatch(cancelDeleteInvoice())
                  }}
                  aria-labelledby="alert-dialog-title"
                  aria-describedby="alert-dialog-description"
                  BackdropProps={{
                    classes: {
                      root: classes.root
                    }
                  }}
                >
                  <DialogTitle id="alert-dialog-title">
                    <span style={{ fontSize: '20px' }}>
                      {t('invoice.dialogTitle')}
                    </span>
                  </DialogTitle>
                  <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                      <span style={{ fontSize: '14px' }}>
                        {t('invoice.dialogContent')}
                      </span>
                    </DialogContentText>
                  </DialogContent>
                  <DialogActions>
                    <div className="pull-right">
                      <Button
                        variant="outlined"
                        className={classes.button}
                        onClick={() => {
                          dispatch(cancelDeleteInvoice())
                        }}
                      >
                        {t('invoice.dialogCancel')}
                      </Button>
                      <Button
                        variant="contained"
                        className={classes.button}
                        onClick={() => {
                          dispatch(
                            removeInvoice(
                              isToDeleteInvoiceId,
                              isToDetach_workshift_journal_id
                            )
                          )
                        }}
                      >
                        {t('invoice.dialogDelete')}
                      </Button>
                    </div>
                  </DialogActions>
                </Dialog>
              </TableCell>
            </TableRow>
            {!mobileView ? null : (
              <TableRow
                style={{
                  height: '0px',
                  background: index % 2 ? 'white' : '#ebf9fa'
                }}
              >
                <TableCell style={{ padding: '0 0' }} colSpan={20}>
                  <Collapse in={open} timeout="auto" unmountOnExit>
                    <div style={{ paddingBottom: '10px' }}>
                      <Table>
                        <TableHead>
                          <TableRow className={classes.collapseTableRow}>
                            <TableCell
                              className={classNames(
                                classes.collapseTableHeader,
                                classes.collapseColumn1
                              )}
                            >
                              {t('invoice.column')}
                            </TableCell>
                            <TableCell
                              className={classNames(
                                classes.collapseTableHeader,
                                classes.collapseColumn3
                              )}
                            >
                              {t('invoice.column6')}
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          <TableRow className={classes.collapseTableRow}>
                            <TableCell
                              className={classNames(
                                classes.collapseTableCell,
                                classes.collapseColumn1
                              )}
                            >
                              {customer}
                            </TableCell>
                            <TableCell
                              className={classNames(
                                classes.collapseTableCell,
                                classes.collapseColumn3
                              )}
                            >
                              <div
                                style={getInvoiceStatusStyle(
                                  status,
                                  invoiceRowData.due_date
                                )}
                              >
                                {convertIntToState(status, 'userView')}
                              </div>
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      </Table>
                    </div>
                  </Collapse>
                </TableCell>
              </TableRow>
            )}
          </React.Fragment>
        )
      }}
    </Translation>
  )
}

const handleEditInvoice = (id, dispatch) => {
  dispatch(showInvoiceFormDialog())
  dispatch(editInvoice(id))
}

const handleCopyInvoice = (id, dispatch) => {
  dispatch(showInvoiceFormDialog())
  dispatch(copyInvoice(id))
}

const actionsByState = (status, invoice_id, dispatch) => (
  <Translation>
    {(t) => {
      return status === 0 ? (
        <p
          style={{ margin: '10px 15px 10px 10px' }}
          className="link"
          onClick={() => {
            handleEditInvoice(invoice_id, dispatch)
          }}
        >
          <FontAwesome
            title={t('iconTitle.editInvoice')}
            name="pencil"
            size="lg"
          />
        </p>
      ) : (
        <p
          style={{ margin: '10px 15px 10px 10px' }}
          className="link"
          onClick={() => {
            handleCopyInvoice(invoice_id, dispatch)
          }}
        >
          <FontAwesome
            title={t('iconTitle.copyInvoice')}
            name="clone"
            size="lg"
          />
        </p>
      )
    }}
  </Translation>
)

InvoiceRow.propTypes = {
  classes: PropTypes.object.isRequired
}

export default withStyles(styles)(InvoiceRow)
